import EyeDrawSection from '../EyeDrawSection';
import thumb12 from '../images/thumb_12.jpg';
import thumb13 from '../images/thumb_13.jpg';
import img12 from '../images/12.png';
import img13 from '../images/13.png';

const cards = [
    { title: 'Pathology Eyelids - Blepharitis', thumb: thumb12, image: img12 },
    { title: 'Pathology Eyelids - Stye/Hordeolum', thumb: thumb13, image: img13 },
];

export default function Pathology() {
    return (
        <EyeDrawSection id="pathology-eyelids" title="Pathology Eyelids" icon="bi-bandaid" cards={cards} />
    );
}
